// Breathing status pulse — signature moment.
// Used wherever we surface "agent is alive" or "active visitor".

interface Props {
  label?: string;
  tone?: 'live' | 'accent';
}

export const LivePulse = ({ label = 'Live', tone = 'live' }: Props) => {
  const dot = tone === 'live' ? '#10B981' : '#6366F1';
  return (
    <span className="inline-flex items-center gap-2 rounded-full bg-white border border-line py-1 pl-2 pr-2.5 text-[11.5px] font-medium leading-none text-ink-soft">
      <span className="relative inline-block w-2 h-2">
        <span
          className="absolute inset-0 rounded-full opacity-40 animate-live-ping"
          style={{ background: dot }}
        />
        <span
          className="absolute inset-[2px] rounded-full"
          style={{ background: dot }}
        />
      </span>
      {label}
    </span>
  );
};
